<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M2.5 13.5L13.5 5.5" stroke="#E5E5E5" stroke-width="2.2" stroke-linecap="round"/>
  <path d="M12.5 5.5V14.5" stroke="#E5E5E5" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M10.5 14.5H14.5" stroke="#E5E5E5" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M1.5 14H4.5" stroke="#E5E5E5" stroke-width="1.5" stroke-linecap="round"/>
  <circle cx="13" cy="3.5" r="1.3" fill="#E5E5E5"/>
  <circle cx="14.5" cy="5.5" r="1.3" fill="#E5E5E5"/>
</svg>
